import { Colors, Metrics } from "../../resources";

import React from "react";
import { View } from "react-native";

interface IProps {
  height?: number;
  width?: number | string;
  color?: string;
}

const SDivider: React.FC<IProps> = ({
  height = Metrics.iconSmall,
  width = 1,
  color = Colors.grey300,
}) => {
  return (
    <View
      style={{
        height: height,
        width: width,
        borderColor: color,
        backgroundColor: color,
      }}
    />
  );
};

export default SDivider;
